import { Injectable } from "@angular/core";
import { TranslateService } from "../../translate.service";

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}
var lang = localStorage.getItem("lang");
var user_role = localStorage.getItem("node_role");
var MOMENTAMENU1 = [
  {
    label: lang == "TH" ? " " : " ",
    main: [
      {
        state: "realtimeConfirm",
        name: lang == "TH" ? "ตรวจสอบข้อมูลก่อนลูกค้า" : "Confirm Data",
        type: "link",
        icon: "ti-settings",
      },
      {
        state: "dashboard",
        name: lang == "TH" ? "ข้อมูลรถ (Realtime)" : "Realtime Data",
        type: "link",
        icon: "ti-bar-chart",
      },
      {
        state: "gps",
        name: lang == "TH" ? "ข้อมูลรถ (History)" : "History",
        type: "link",
        icon: "ti-map-alt",
      },
      {
        state: "warning",
        name: lang == "TH" ? "ค้นหาการแจ้งเตือน" : "Warning Searching",
        type: "link",
        icon: "ti-alert",
      },
      {
        state: "warningreport",
        name: lang == "TH" ? "รายงานการแจ้งเตือน" : "Warning summary",
        type: "link",
        icon: "ti-image", //realtimecamera
      },
      {
        state: "regiscamera",
        name: lang == "TH" ? "ลงทะเบียนตัวกล้อง" : "Camera Register",
        type: "link",
        icon: "ti-camera",
      },
      {
        state: "movenoconfig",
        name: lang == "TH" ? "จัดการอุปกรณ์" : "Moving No Config",
        type: "link",
        icon: "ti-layers",
      },
      {
        state: "usermanage",
        name: lang == "TH" ? "ลงทะเบียนผู้ใช้งาน" : "User management",
        type: "link",
        icon: "ti-user",
      },
      {
        state: "managecamerauser",
        name:
          lang == "TH"
            ? user_role == "1"
              ? "จัดการผู้ใช้กล้อง"
              : "จัดการกลุ่มของกล้อง"
            : user_role == "1"
            ? "Camera Management"
            : "Camera Group Management",
        type: "link",
        icon: "ti-user",
      },

      {
        state: "soundsetting",
        name: lang == "TH" ? "ตั้งค่าเสียง" : "Sound setting",
        type: "link",
        icon: "ti-volume",
      },
      {
        state: "warningconfig",
        name: lang == "TH" ? "ตั้งค่าการแจ้งเตือน" : "Warning Config",
        type: "link",
        icon: "ti-settings",
      },
      // {
      //   state: "realtimewarning",
      //   name: lang == "TH" ? "ติดตามการแจ้งเตือน" : "Realtime Warning",
      //   type: "link",
      //   icon: "ti-announcement",
      // },

      {
        state: "warninguserconfig",
        name:
          lang == "TH" ? "ตั้งค่าการแจ้งเตือนแยกผู้ใช้" : "Warning User config",
        type: "link",
        icon: "ti-image", //realtimecamera
      },
    ],
  },
];

var MOMENTAMENU11 = [
  {
    label: lang == "TH" ? " " : " ",
    main: [
      {
        state: "realtimeConfirm",
        name: lang == "TH" ? "ตรวจสอบข้อมูลก่อนลูกค้า" : "Confirm Data",
        type: "link",
        icon: "ti-settings",
      },
      {
        state: "dashboard",
        name: lang == "TH" ? "ข้อมูลรถ (Realtime)" : "Realtime Data",
        type: "link",
        icon: "ti-bar-chart",
      },
      {
        state: "gps",
        name: lang == "TH" ? "ข้อมูลรถ (History)" : "History",
        type: "link",
        icon: "ti-map-alt",
      },
      {
        state: "warning",
        name: lang == "TH" ? "ค้นหาการแจ้งเตือน" : "Warning Searching",
        type: "link",
        icon: "ti-alert",
      },
      {
        state: "warningreport",
        name: lang == "TH" ? "รายงานการแจ้งเตือน" : "Warning summary",
        type: "link",
        icon: "ti-image", //realtimecamera
      },
      {
        state: "regiscamera",
        name: lang == "TH" ? "ลงทะเบียนตัวกล้อง" : "Camera Register",
        type: "link",
        icon: "ti-camera",
      },
      {
        state: "movenoconfig",
        name: lang == "TH" ? "จัดการอุปกรณ์" : "Moving No Config",
        type: "link",
        icon: "ti-layers",
      },
      {
        state: "usermanage",
        name: lang == "TH" ? "ลงทะเบียนผู้ใช้งาน" : "User management",
        type: "link",
        icon: "ti-user",
      },
      {
        state: "managecamerauser",
        name:
          lang == "TH"
            ? user_role == "1"
              ? "จัดการผู้ใช้กล้อง"
              : "จัดการกลุ่มของกล้อง"
            : user_role == "1"
            ? "Camera Management"
            : "Camera Group Management",
        type: "link",
        icon: "ti-user",
      },

      {
        state: "soundsetting",
        name: lang == "TH" ? "ตั้งค่าเสียง" : "Sound setting",
        type: "link",
        icon: "ti-volume",
      },
      {
        state: "warningconfig",
        name: lang == "TH" ? "ตั้งค่าการแจ้งเตือน" : "Warning Config",
        type: "link",
        icon: "ti-settings",
      },
      // {
      //   state: "realtimewarning",
      //   name: lang == "TH" ? "ติดตามการแจ้งเตือน" : "Realtime Warning",
      //   type: "link",
      //   icon: "ti-announcement",
      // },

      {
        state: "warninguserconfig",
        name:
          lang == "TH" ? "ตั้งค่าการแจ้งเตือนแยกผู้ใช้" : "Warning User config",
        type: "link",
        icon: "ti-image", //realtimecamera
      },
    ],
  },
];

var MOMENTAMENU2 = [
  {
    label: "Main",
    main: [
      {
        state: "realtimeConfirm",
        name: lang == "TH" ? "ตรวจสอบข้อมูลก่อนลูกค้า" : "Confirm Data",
        type: "link",
        icon: "ti-settings",
      },
      {
        state: "dashboard",
        name: lang == "TH" ? "ข้อมูลรถ (Realtime)" : "Realtime Data",
        type: "link",
        icon: "ti-bar-chart",
      },
      {
        state: "gps",
        name: lang == "TH" ? "ข้อมูลรถ (ย้อนหลัง)" : "History",
        type: "link",
        icon: "ti-map-alt",
      },
      {
        state: "warning",
        name: lang == "TH" ? "ค้นหาการแจ้งเตือน" : "Warning Searching",
        type: "link",
        icon: "ti-alert",
      },
      {
        state: "managecamerauser",
        name: lang == "TH" ? "จัดการกลุ่มของกล้อง" : "Camera Management",
        type: "link",
        icon: "ti-camera",
      },
      {
        state: "movenoconfig",
        name: lang == "TH" ? "จัดการอุปกรณ์(IMEI)" : "Moving No Config",
        type: "link",
        icon: "ti-layers",
      },
      // {
      //   state: "usermanage",
      //   name: lang == "TH" ? "ตั้งค่าบัญชีผู้ใช้" : "User management",
      //   type: "link",
      //   icon: "ti-user"
      // },
      {
        state: "warningconfig",
        name: lang == "TH" ? "ตั้งค่าการแจ้งเตือน" : "Warning Config",
        type: "link",
        icon: "ti-settings",
      },
      {
        state: "warningreport",
        name: lang == "TH" ? "รายงานการแจ้งเตือน" : "Warning summary",
        type: "link",
        icon: "ti-image", //realtimecamera
      },
      // {
      //   state: "realtimewarning",
      //   name: lang == "TH" ? "ติดตามการแจ้งเตือน" : "Realtime Warning",
      //   type: "link",
      //   icon: "ti-announcement"
      // },
      {
        state: "soundsetting",
        name: lang == "TH" ? "ตั้งค่าเสียง" : "Sound setting",
        type: "link",
        icon: "ti-volume",
      },
    ],
  },
];

const MOMENTAMENU3 = [
  {
    label: "Main",
    main: [
      {
        state: "dashboard",
        name: lang == "TH" ? "ข้อมูลรถ (Realtime)" : "Realtime Data",
        type: "link",
        icon: "ti-bar-chart",
      },
      {
        state: "gps",
        name: lang == "TH" ? "ข้อมูลรถ (ย้อนหลัง)" : "History",
        type: "link",
        icon: "ti-map-alt",
      },
      {
        state: "managecamerauser",
        name: lang == "TH" ? "จัดการกลุ่มของกล้อง" : "Camera Management",
        type: "link",
        icon: "ti-camera",
      },
      {
        state: "warning",
        name: lang == "TH" ? "ค้นหาการแจ้งเตือน" : "Warning Searching",
        type: "link",
        icon: "ti-alert",
      },
      {
        state: "warningreport",
        name: lang == "TH" ? "รายงานการแจ้งเตือน" : "Warning summary",
        type: "link",
        icon: "ti-image",
      },
      // {
      //   state: "realtimewarning",
      //   name: lang == "TH" ? "ติดตามการแจ้งเตือน" : "Realtime Warning",
      //   type: "link",
      //   icon: "ti-announcement"
      // },
      {
        state: "soundsetting",
        name: lang == "TH" ? "ตั้งค่าเสียง" : "Sound setting",
        type: "link",
        icon: "ti-volume",
      },
    ],
  },
];

const MOMENTAMENU4 = [
  {
    label: "Main",
    main: [
      {
        state: "managecamerauser",
        name: lang == "TH" ? "จัดการผู้ใช้กล้อง" : "Camera Management",
        type: "link",
        icon: "ti-user",
      },
      // ,
      // {
      //   state: "realtimecamera",
      //   name: lang == "TH" ? "ข้อมูล MDVR" : "MDVR",
      //   type: "link",
      //   icon: "ti-video-camera"
      // }
    ],
  },
];

const EZYNODE = [
  {
    label: "Main",
    main: [
      {
        state: "ezygetconfig",
        name: "Get Config",
        type: "link",
        icon: "ti-user",
      },
      {
        state: "ezyrealtime",
        name: "Realtime",
        type: "link",
        icon: "ti-video-camera",
      },
      {
        state: "ezyhistory",
        name: "History",
        type: "link",
        icon: "ti-video-camera",
      },
    ],
  },
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    if (localStorage.getItem("node_role") == "1") {
      if (localStorage.getItem("minieye") == "1") {
        return MOMENTAMENU1;
      } else {
        return MOMENTAMENU11;
      }
    } else if (localStorage.getItem("node_role") == "2") return MOMENTAMENU2;
    else {
      return MOMENTAMENU3;
    }
  }
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/shared/menu-items/menu-items.ts